module.exports.testDataForGetter = [
  'eerste optie',
  'tweede optie',
  'derde optie',
  'vierde optie',
  'vijfde optie',
  'zesde optie',
]
